import { render, staticRenderFns } from "./changeLocalesPicker.vue?vue&type=template&id=7c9214f7&scoped=true"
import script from "./changeLocalesPicker.vue?vue&type=script&lang=js"
export * from "./changeLocalesPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9214f7",
  null
  
)

export default component.exports